import { gql } from '@apollo/client';

const PRODUCT_USER_EXAMS = gql`
  query ProductUserExams($input: ProductInput!) {
    product(input: $input) {
      product {
        uuid
        userExams {
          uuid
          status
          score
          variant
          startedAt
          finishedAt
          points
          pointsTotal
        }
        essayResponses {
          uuid
          essayPrompt {
            uuid
            type
          }
          score
          startedAt
          submitAt
          createdAt
        }
        userExamsFeedback {
          type
          data
          message
        }
      }
    }
  }
`;

export default PRODUCT_USER_EXAMS;
